import { Controller } from "@hotwired/stimulus"
import { apiJson, formatApiErrorDetail } from "../lib/api_errore"

// Azioni di ConversionePanel.js. Sta fuori dal frame `conversione-panel` (che si rilegge dopo ogni azione):
// «Esegui backup ora» (POST backup/run), «Applica», «Annulla conversione» (toast, poi il frame riletto), «Aggiorna».
export default class extends Controller {
  static values = { url: String, backupUrl: String }

  async azione({ params: { cosa } }) {
    if (this.occupato) return
    this.blocca(cosa)
    try {
      if (cosa === "backup") {
        await apiJson(this.backupUrlValue, { method: "POST" })
        window.toast?.success("Backup avviato: quando è finito premi \"Aggiorna\".")
      } else if (cosa === "applica") {
        const data = await apiJson(`${this.urlValue}/applica`, { method: "POST" })
        window.toast?.success(`Conversione applicata in ${data.projects} progetti`)
      } else {
        const data = await apiJson(`${this.urlValue}/annulla`, { method: "POST" })
        window.toast?.success(`Conversione annullata: ${data.restored} voci riportate alla categoria precedente` +
          (data.kept ? `, ${data.kept} lasciate come le ha cambiate il consulente` : ""))
      }
      await this.ricarica()
    } catch (e) {
      window.toast?.error(formatApiErrorDetail(e.detail))
    } finally {
      this.sblocca()
    }
  }

  async aggiorna() {
    if (this.occupato) return
    this.blocca("aggiorna")
    try { await this.ricarica() } finally { this.sblocca() }
  }

  get frame() {
    return this.element.querySelector("turbo-frame#conversione-panel")
  }

  ricarica() {
    const frame = this.frame
    if (!frame) return Promise.resolve()
    return new Promise((ok) => {
      frame.addEventListener("turbo:frame-load", () => ok(), { once: true })
      frame.reload()
    })
  }

  // Come `busy` dell'originale: tutti i pulsanti fermi, e il giro di attesa sul pulsante premuto.
  blocca(cosa) {
    this.occupato = true
    this.element.querySelectorAll("[data-conversione-panel-target='azione']").forEach((b) => {
      b.dataset.eraFermo = b.disabled ? "1" : ""
      b.disabled = true
    })
    this.element.querySelectorAll("[data-cosa]").forEach((el) => {
      const attesa = el.dataset.conversionePanelTarget === "attesa"
      if (el.dataset.cosa === cosa) el.hidden = !attesa
    })
  }

  sblocca() {
    this.occupato = false
    this.element.querySelectorAll("[data-conversione-panel-target='azione']").forEach((b) => {
      if (b.dataset.eraFermo !== undefined) { b.disabled = b.dataset.eraFermo === "1"; delete b.dataset.eraFermo }
    })
    this.element.querySelectorAll("[data-cosa]").forEach((el) => {
      el.hidden = el.dataset.conversionePanelTarget === "attesa"
    })
  }
}
